import { useContext } from "react";
import classes from "./Profile.module.scss";
import {updateProfile} from '../../services';
import useInput from "../../hooks/use-inputs";
import AuthContext from "../../store/auth-context";

const Password = ({setActiveTab}) => {
    const authCtx = useContext(AuthContext);
    // Login list removed

    const {
        value: currentPassword,
        valueIsValid: currentPasswordIsValid,
        // eslint-disable-next-line no-unused-vars
        hasError: hasCurrentPasswordError,
        inputChangeHandler: currentPasswordInputChangeHandler,
        inputBlurHandler: currentPasswordInputBlurHandler,
        reset: resetCurrentPassword,
      } = useInput((value) => value.trim() !== "" && value.length >= 6);

    const {
        value: newPassword,
        valueIsValid: newPasswordIsValid,
        // eslint-disable-next-line no-unused-vars
        hasError: hasNewPasswordError,
        inputChangeHandler: newPasswordInputChangeHandler,
        inputBlurHandler: newPasswordInputBlurHandler,
        reset: resetNewPassword,
      } = useInput((value) => value.trim() !== "" && value.length >= 6);

    const {
        value: confirmNewPassword,
        valueIsValid: confirmNewPasswordIsValid,
        // eslint-disable-next-line no-unused-vars
        hasError: hasConfirmNewPasswordError,
        inputChangeHandler: confirmNewPasswordInputChangeHandler,
        inputBlurHandler: confirmNewPasswordInputBlurHandler,
        reset: resetConfirmNewPassword,
      } = useInput((value) => value.trim() !== "" && value.length >= 6 && value === newPassword);
 
    const resetForm = () => {
        resetCurrentPassword();
        resetNewPassword();
        resetConfirmNewPassword();
      }

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!currentPasswordIsValid || !newPasswordIsValid || !confirmNewPasswordIsValid) return;

    try {
        const response = await updateProfile({currentPassword: currentPassword, password: newPassword});
        if(response?.status === 201){
          resetForm();
          setActiveTab(1);
          // PUT /users now bumps the account's tokenVersion on a password change
          // (Backend/app/controllers/user.controller.js), which is what makes a stolen
          // bearer token stop working. That also revokes THIS session's token, so the
          // next API call would fail with a bare 401 and axiosHandler would bounce the
          // user to /login with no explanation. Say so, then sign them out cleanly.
          window.alert("Your password has been changed. Please sign in again with your new password.");
          if (authCtx?.logout) {
            authCtx.logout();
          }
          window.location.href = window.location.origin + "/login";
          return;
        }
        // axiosHandler resolves any status <= 500 AND resolves with the response BODY,
        // so a 400 ("Current password is incorrect", a rejected weak password) arrives
        // here as `{ message, code: 400 }` rather than in catch.
        window.alert(response?.message || "Failed to update your password. Please try again.");
      } catch (error) {
        console.error("An error occurred while submitting the form:", error);
      }
  }
      
  return (
    <div className={classes.passWrapper}>
        <div className={classes.passForm}>
            <div className={classes.mb4}>
                <h4 className={classes.headingH3}>Password</h4>
                <p className={classes.subHeading}>Please enter your current password to change your password.</p>
            </div>
            
            <hr/>

            <form onSubmit={submitHandler} className={classes.passFormInner}>
                <div className={`${classes.formGroup} ${classes.mb4}`}>
                    <label className={classes.formLabel}>Current Password</label>
                    <input 
                        type="password" 
                        name="currentpassword"
                        placeholder="Type Current Password"
                        className={classes.formInput}
                        value={currentPassword}
                        onChange={currentPasswordInputChangeHandler}
                        onBlur={currentPasswordInputBlurHandler}
                    />
                </div>

                <div className={`${classes.formGroup} ${classes.mb4}`}>
                    <label className={classes.formLabel}>New Password</label>
                    <input
                        type="password"
                        name="newpassword"
                        placeholder=""
                        className={classes.formInput}
                        value={newPassword}
                        onChange={newPasswordInputChangeHandler}
                        onBlur={newPasswordInputBlurHandler}
                    />
                </div>

                <div className={`${classes.formGroup} ${classes.mb4}`}>
                    <label className={classes.formLabel}>Confirm New Password</label>
                    <input
                        type="password"
                        name="confirmnewpassword"
                        placeholder=""
                        className={classes.formInput}
                        value={confirmNewPassword}
                        onChange={confirmNewPasswordInputChangeHandler}
                        onBlur={confirmNewPasswordInputBlurHandler}
                    />
                </div>

                <div className={classes.passFormButtons}>
                    <button className={classes.formButtonPrimary}>Update password</button>
                </div>
            </form>
        </div>
    </div>
  )
}

export default Password